import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
export interface Role {
  /** 菜单权限id */
  menu_ids?: string[]
  /** 角色id */
  role_id?: string
  /** 描述 */
  remark?: string
  /** 角色名 */
  role_name?: string
  menuCheckStrictly?: boolean
  count?:number

}
export interface GetRoleInfo {
  menu_ids?: string[]
}
export interface RoleListParams {
  /** 与 roledto */
  id: string
  role_name: string
  role_key: string
  remark: string
  ctime: string
  mtime: string
  is_del: number
  invalid: number
}
export interface RoleList {
  /** 角色列表 */
  list?: RoleListParams[]
  /** 总数量 */
  total?: string
}
export interface RoleBindParams {
  /** 菜单权限id */
  menu_ids?: string[]
  /** 角色id */
  role_id?: string
}
export interface MenuList {
  menu_id: string
  menu_name: string
  parent_id: string
  order_num: number
  path: string
  perms: string
  children: undefined[]
}
@Injectable()
export class RoleService {
  constructor(private http: Http) {
  }
  // 新增/修改角色
  getRoleSubmit(data: RoleListParams) {
    return this.http.post(`/role/${data.id ? 'update' : 'add'}`, data)
  }
  getRoleDelete(data: { ids: string[] }) {
    return this.http.post<void>('/role/delete', data)
  }
  // 根据角色获取菜单列表
  getRoleMenu(id: { id: string }) {
    return this.http.post<GetRoleInfo>('/role/get_role_menu', { id })
  }
  // 角色列表
  getRoleList(data: RoleListParams) {
    return this.http.post<RoleList>('/role/list', data)
  }
  // 获取菜单列表
  getMenuList() {
    return this.http.post<MenuList[]>('/menu/list', {})
  }
}
